<template>
    <div class="container d-flex justify-content-center">
        <div class="flex-grow-1" style="max-width: 612px; min-width: 0">
            <div>
                <div class="fw-700 mb-2 fs-4 d-flex align-items-center flex-wrap" style="gap: 0 12px">
                    {{$trans('storefront::flexible_packaging.please_upload_your_files')}}

                    <span class="text-muted fs-5 text-truncate fw-400" style="flex: 1 1 120px" :title="mimes">({{mimes}})</span>
                </div>
                <div class="d-flex flex-column flex-sm-row gap-2 cursor-pointer" @click="handleFileUploadClick">
                    <input type="text" class="form-control-secondary pe-none" :placeholder="$trans('storefront::flexible_packaging.select_files_to_upload')">

                    <button type="button" class="btn btn-primary btn-special-size text-uppercase text-nowrap d-flex align-items-center justify-content-center gap-2" style="border-radius: 0">
                        <i class="las la-cloud-upload-alt" style="font-size: 22px"></i>
                        {{$trans('storefront::flexible_packaging.upload_file')}}
                    </button>
                </div>

                <scroll-box class="mt-2" style="max-height: 300px">
                    <file-upload id="file-upload" :files="store.files" :accept="store.mediaOptions.mimes"></file-upload>
                </scroll-box>
            </div>

            <div class="spacer-32"></div>
            <div class="d-flex flex-column-reverse flex-sm-row justify-content-sm-end gap-2">
                <button type="button" class="btn btn-outline-secondary text-uppercase" style="min-width: 150px" @click="store.previousStep">{{$trans('storefront::flexible_packaging.previous')}}</button>
                <button type="button" class="btn btn-secondary text-uppercase" style="min-width: 150px" @click="store.nextStep">{{$trans('storefront::flexible_packaging.next')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../js/store";
import FlexiblePackagingOption from "../inc/FlexiblePackagingOption";

export default {
    components: {FlexiblePackagingOption},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    computed: {
        mimes: function() {
            const extensions = this.store.mediaOptions.mimes;
            return extensions.replace(/,/g, ', ');
        }
    },
    methods: {
        handleFileUploadClick() {
            $('#file-upload').click();
        }
    }
}
</script>
